/** Path matches; every search param on `linkHref` must match `asPath` (extra params on current URL allowed). */
export function pathQueryPrefixMatches(asPath: string, linkHref: string): boolean {
  const [linkPath, linkQuery = ''] = linkHref.split('?');
  const [currPath, currQuery = ''] = asPath.split('?');
  if (currPath !== linkPath) return false;
  const linkParams = new URLSearchParams(linkQuery);
  const currParams = new URLSearchParams(currQuery);
  for (const [key, value] of linkParams.entries()) {
    if (currParams.get(key) !== value) return false;
  }
  return true;
}

export function pathMatchesCurrentRoute(asPath: string, href: string) {
  const [hrefPath, hrefQuery] = href.split('?');
  const [currPath, currQuery] = asPath.split('?');
  if (hrefPath !== currPath) return false;
  if (!hrefQuery) return true;
  return currQuery === hrefQuery || (currQuery ?? '').startsWith(`${hrefQuery}&`);
}

/** Sub-nav links: same path; required params from `href` must match; `tab` defaults to 0 when omitted in `href`. */
export function pathMatchesSettingsTabSubItem(asPath: string, href: string): boolean {
  const [hrefPath, hrefQuery = ''] = href.split('?');
  const [currPath, currQuery = ''] = asPath.split('?');
  if (currPath !== hrefPath) return false;
  const hrefParams = new URLSearchParams(hrefQuery);
  const currParams = new URLSearchParams(currQuery);
  for (const [key, value] of hrefParams.entries()) {
    if (key === 'tab') continue;
    if (currParams.get(key) !== value) return false;
  }
  const hrefTab = parseInt(hrefParams.get('tab') || '0', 10) || 0;
  const pathTab = parseInt(currParams.get('tab') || '0', 10) || 0;
  return hrefTab === pathTab;
}

/** Parent row auto-expand / click-away: pathname + minimum query for each submenu. */
export const SETTINGS_SUBMENU_ROUTE_MATCH: Record<string, { pathname: string; linkPrefix: string }> = {
  jobs: { pathname: '/settings/jobs', linkPrefix: '/settings/jobs' },
  candidates: { pathname: '/settings/candidates', linkPrefix: '/settings/candidates' },
  clients: { pathname: '/settings/clients', linkPrefix: '/settings/clients' },
};

export function settingsSubmenuKeyForRoute(pathname: string, asPath: string): string | null {
  for (const [key, cfg] of Object.entries(SETTINGS_SUBMENU_ROUTE_MATCH)) {
    if (pathname !== cfg.pathname) continue;
    if (pathQueryPrefixMatches(asPath, cfg.linkPrefix)) return key;
  }
  return null;
}

export function submenuStaysOpenOnClickAway(submenuKey: string, pathname: string, asPath: string): boolean {
  const cfg = SETTINGS_SUBMENU_ROUTE_MATCH[submenuKey];
  if (!cfg) return false;
  if (pathname !== cfg.pathname) return false;
  return pathQueryPrefixMatches(asPath, cfg.linkPrefix);
}
